<bw-action-article-legacy [brightsideWebFb]="{event_name: 'savi_info'}">
  <ui-nav-exit-back
    header-actions
    (exitActionHandler)="goBackToSplash()"
    [trackingDetail]="{ event_name: 'savi_info' }"
  ></ui-nav-exit-back>
  <div content-section>
    <div class="mb-md">
      <div class="img-wrapper mb-sm">
        <img src="./assets/student-loans-help.png">
      </div>
      <typography-legacy title-large>{{ 'SAVI_INFO_TITLE' | translate }}</typography-legacy>
    </div>
    <typography-legacy color="var(--secondary-text)">
      <bw-paragraph-legacy>
        {{ 'SAVI_INFO_DESC' | translate }}
      </bw-paragraph-legacy>
      <div *ngFor="let i of [].constructor(4); let index = index" class="flex-row space-between align-center pb-xs">
        <div class="align-left mr-sm">
          <bw-icon-legacy [iconName]="'arrow_right'" size="24"></bw-icon-legacy>
        </div>
        <div class="flex-column flex-item-flexible">
          <typography-legacy>{{ 'SAVI_INFO_BULLET_' + index  | translate }}</typography-legacy>
        </div>
      </div>
    </typography-legacy>
  </div>
  <div footer-actions class="flex-row flex-item-flexible space-between">
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'savi_info'}"
        (click)="goToSavi()">
        {{ 'SAVI_INFO_BUTTON' | translate }}
      </button>
      <button
        bw-link-button-legacy
        (click)="exitToChat()"
        [brightsideWebFb]="{ event_name: 'savi_info'}" [secondaryCta]="true">
        {{ 'SAVI_INTO_CHAT_BUTTON' | translate }}
      </button>
  </div>
</bw-action-article-legacy>


